import { useContext, useEffect, useState } from "react";
import { fetchAPI } from "../api/api";
import { GridLayout } from "./layout";
import { ProgressObj } from "../molecule/progressObj";
import { PageContext } from "../App";
import {EmptyComp} from "./emptyComp"
import { TitleAtom } from "../atoms/titleAtom";
import { TitleAction } from "../molecule/TitleAction";
import { padding } from "polished";

export const ProgressComp = ({
  title,
  endpoint,
  badge,
  label,
  showMoreLimit = 5,
  finished,
  progress, 
  user,
  userDepartment,
}) => {
  const [progressData, setProgress] = useState([]);
  const [showMore, setShowMore] = useState(false);
  const [showMoreVisible, setShowMoreVisible] = useState(false);
  const navigationContext = useContext(PageContext);
  const [dynamicShowMoreLimit, setDynamicShowMoreLimit] =
    useState(showMoreLimit);
  
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setDynamicShowMoreLimit(
        width < 768
          ? 1
          : width >= 768 && width <= 1024
          ? 2
          : width >= 1024 && width <= 1280
          ? 4
          : showMoreLimit
      );
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [showMoreLimit]);

  useEffect(() => {
    loadProgress();
  }, [navigationContext]);

  const getBadgeAndLabel = (courseProgress) => {
    let badge = "default";
    let label = "In uitvoering";

    if (courseProgress >= 100) {
      badge = "succes";
      label = "Afgerond";
    }
    return { badge, label };
  };

  const loadProgress = async () => {
    try {
      const query = `api/users/${endpoint}`;
      const courseData = await fetchAPI(query);
      console.log("courseData", courseData);

     if (Array.isArray(courseData)) {
      let filteredData = courseData;

      if (finished || progress) {
        filteredData = filteredData.filter((item) => item.course_status === 0);
      }

        setProgress(filteredData);
        setShowMoreVisible(filteredData.length > dynamicShowMoreLimit);
      } else {
        console.warn("API response is not in the expected format or is empty");
      }
    } catch (error) {
      console.error("Error fetching progress data:", error);
    }
  };

  return (
    <div className="standard-padding">
      <TitleAction style={{ padding: "0" }} ProfileClassName="profile-sub-title standard-margin-bottom standard-margin-top" title={title} buttonTitle={showMore ? "Toon minder" : "Toon meer"} onClick={() => setShowMore(!showMore)} hideBtn={!showMoreVisible}/>
      {progressData.length === 0 ? (
        <GridLayout className="progress-grid" columnsTemplate="1fr" style={{ width: "25%" }}>
          <EmptyComp
            userName={user?.full_name}
            hasCourses={progressData.length > 0}
            userID={navigationContext.sidebar.userId}
            navigationContext={navigationContext}
          />
        </GridLayout>
      ) : (
        <GridLayout
          className="progress-grid"
          columnsTemplate="repeat(5, 1fr)"
          rowTemplate="repeat(1, auto)"
          gap="16px"
        >
          {progressData
            .slice(0, showMore ? progressData.length : dynamicShowMoreLimit)
            .map((progress, index) => {
              const percentage = Number(progress.progress);
              const { badge: courseBadge, label: courseLabel } =
                getBadgeAndLabel(percentage);
               
              return (
                
                <ProgressObj
                  className={progress.readable ? "" : "not-clickable"}
                  key={index}
                  onClick={() =>
                      navigationContext.handleNavigation({
                      courseID: progress.id_course,
                      navigation: 7,
                      enrollment: progress.id_course_enrollments,
                      userID:navigationContext.sidebar.userId
                    })
                  }
                  data={progress}
                  title={progress.course_name}
                  badge={courseBadge}
                  label={courseLabel}
                  percentage={percentage}
                  image={progress.course_image}
                  message={progress.readable ? "" : "Geen toegang tot cursus"}
                />
              );
            })}
        </GridLayout>
      )}
    </div>
  );
};
